type className = string | undefined | boolean

export const classNames = (classNames: className[]) => {
	return classNames.filter(cls => !!cls).join(" ")
}
